import { render, staticRenderFns } from "./sub_reflect.vue?vue&type=template&id=0ff65656&scoped=true"
import script from "./sub_reflect.vue?vue&type=script&lang=js"
export * from "./sub_reflect.vue?vue&type=script&lang=js"
import style0 from "./sub_reflect.vue?vue&type=style&index=0&id=0ff65656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff65656",
  null
  
)

export default component.exports